'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WordPressSignupCompleted = exports.WordPressIntroHandler = exports.StandaloneCmsRegistration = exports.ClientCompanyAndDomain = exports.PartnerAccountRedirect = exports.PartnerProvision = exports.PartnerListOfExistingAccounts = exports.AcademySurvey = exports.StandardSurvey = exports.CompleteVerification = exports.CompanyDomain = exports.CheckYourEmail = exports.UserRegistrationEmbeddedCompact = exports.AcademySetup = exports.PartnerClientRegistration = exports.ClientEmailAndDomain = exports.UserRegistrationUser = exports.AccountRegistration = exports.EmployeeRegistration = exports.UserRegistration = exports.ContinueWithRecommendedAccount = exports.ListOfExistingAccountsMinimal = exports.ListOfExistingAccounts = exports.DomainOnly = exports.ExistingUserHubless = exports.AuthedStartDisplay = exports.GettingStarted = exports.Activate = exports.ExistingAccountLogin = exports.GoogleOAuthLanding = exports.GoogleOAuth = exports.FbGoToLogin = exports.PartnerGoToLogin = exports.GoToLogin = exports.GeneralError = exports.TokenError = exports.SignupFlow = exports.Application = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Application = exports.Application = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/application" */'./Application');
});
var SignupFlow = exports.SignupFlow = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/signupflow" */'./SignupFlow');
});
var TokenError = exports.TokenError = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/tokenerror" */'./TokenError');
});
var GeneralError = exports.GeneralError = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/generalerror" */'./GeneralError');
});
var GoToLogin = exports.GoToLogin = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/gotologin" */'./GoToLogin');
});
var PartnerGoToLogin = exports.PartnerGoToLogin = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/partnergotologin" */'./PartnerGoToLogin');
});
var FbGoToLogin = exports.FbGoToLogin = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/fbgotologin" */'./FbGoToLogin');
});
var GoogleOAuth = exports.GoogleOAuth = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/oauth/googleoauth" */'./OAuth/GoogleOAuth');
});
var GoogleOAuthLanding = exports.GoogleOAuthLanding = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/oauth/googleoauthlanding" */'./OAuth/GoogleOAuthLanding');
});
var ExistingAccountLogin = exports.ExistingAccountLogin = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/existingaccountlogin" */'./ExistingAccountLogin');
});
var Activate = exports.Activate = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/activate" */'./Activate');
});
var GettingStarted = exports.GettingStarted = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/gettingstarted" */'./GettingStarted/GettingStarted');
});
var AuthedStartDisplay = exports.AuthedStartDisplay = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/detectauth/authedstartdisplay", webpackPrefetch: true */'./DetectAuth/AuthedStartDisplay');
});
var ExistingUserHubless = exports.ExistingUserHubless = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/detectauth/existinguserhubless" */'./DetectAuth/ExistingUserHubless');
});
var DomainOnly = exports.DomainOnly = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/domainonly" */'./DomainOnly');
});
var ListOfExistingAccounts = exports.ListOfExistingAccounts = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/listofexistingaccounts" */'./ListOfExistingAccounts/ListOfExistingAccounts');
});
var ListOfExistingAccountsMinimal = exports.ListOfExistingAccountsMinimal = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/listofexistingaccountsminimal" */'./ListOfExistingAccounts/ListOfExistingAccountsMinimal');
});
var ContinueWithRecommendedAccount = exports.ContinueWithRecommendedAccount = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/continuewithrecommendedaccount" */'./ListOfExistingAccounts/ContinueWithRecommendedAccount');
});
var UserRegistration = exports.UserRegistration = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/userregistration" */'./UserRegistration/UserRegistration');
});
var EmployeeRegistration = exports.EmployeeRegistration = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/employeeregistration" */'./UserRegistration/EmployeeRegistration');
});
var AccountRegistration = exports.AccountRegistration = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/accountregistration" */'./UserRegistration/AccountRegistration');
});
var UserRegistrationUser = exports.UserRegistrationUser = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/userregistrationuser" */'./UserRegistration/UserRegistrationUser');
});
var ClientEmailAndDomain = exports.ClientEmailAndDomain = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/clientemailanddomain" */'./UserRegistration/PartnerClient/ClientEmailAndDomain');
});
var PartnerClientRegistration = exports.PartnerClientRegistration = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/partnerclientregistration" */'./UserRegistration/PartnerClient/PartnerClientRegistration');
});
var AcademySetup = exports.AcademySetup = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/academysetup" */'./UserRegistration/academy/AcademySetup');
});
var UserRegistrationEmbeddedCompact = exports.UserRegistrationEmbeddedCompact = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/userregistrationembeddedcompact" */'./UserRegistration/embedded/UserRegistrationEmbeddedCompact');
});
var CheckYourEmail = exports.CheckYourEmail = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/checkyouremail", webpackPrefetch: true */'./verified/CheckYourEmail');
});
var CompanyDomain = exports.CompanyDomain = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/companydomain" */'./verified/CompanyDomain');
});
var CompleteVerification = exports.CompleteVerification = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/completeverification" */'./verified/CompleteVerification');
});
var StandardSurvey = exports.StandardSurvey = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/standardsurvey" */'./verified/StandardSurvey');
});
var AcademySurvey = exports.AcademySurvey = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/academysurvey" */'./verified/AcademySurvey');
});
var PartnerListOfExistingAccounts = exports.PartnerListOfExistingAccounts = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/partnerlistofexistingaccounts" */'./PartnerListOfExistingAccounts');
});
var PartnerProvision = exports.PartnerProvision = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/partnerprovision" */'./PartnerProvision');
});
var PartnerAccountRedirect = exports.PartnerAccountRedirect = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/partneraccountredirect" */'./StandaloneCms/PartnerAccountRedirect');
});
var ClientCompanyAndDomain = exports.ClientCompanyAndDomain = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/clientcompanyanddomain" */'./StandaloneCms/ClientCompanyAndDomain');
});
var StandaloneCmsRegistration = exports.StandaloneCmsRegistration = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/standalonecmsregistration" */'./UserRegistration/StandaloneCms/StandaloneCmsRegistration');
});
var WordPressIntroHandler = exports.WordPressIntroHandler = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/wordpressintro" */'./WordPressIntroHandler');
});
var WordPressSignupCompleted = exports.WordPressSignupCompleted = _react2.default.lazy(function () {
  return import( /* webpackChunkName: "bundles/routehandler/wordpresssignupcompleted" */'../../core/components/wordpress/WordPressSignupCompleted');
});